module.exports = __webpack_public_path__ + "static/media/pending.ba206dd9.svg";